export const TOKEN_EXPIRY_THRESHOLD = 7;
export const setAlertMessage =
  'To prevent this issue in the future, enable expiration alerts in Settings > Notification > Subscription.';

export const expiredAccountNotes = [
  'Your VCS account token has expired. Please renew your token to avoid release failures and to enable "sync with git".',
];
